import { defineStore } from "pinia";
import api from "@/services/api";

export const useAcademicYearStore = defineStore("academicYears", {
    state: () => ({
        academicYears: [],
        activeAcademicYear: null,
        oldActiveAcademicYear: null,
        loading: false,
        fetchedAt: 0,
        ttl: 600_000
    }),

    persist: true,

    actions: {
        async fetchAcademicYear(force = false) {
            const now = Date.now();
            if (!force && this.academicYears && now - this.fetchedAt < this.ttl) return; // cache 1 menit

            const res = await api.get('/academic-years');
            
            this.academicYears = res.data.data;

            const newAcademicYear = res.data.data.find(year => year.active_status);

            if (this.oldActiveAcademicYear && newAcademicYear && this.oldActiveAcademicYear.id !== newAcademicYear.id) {
                this.activeAcademicYear = null;
            }

            this.oldActiveAcademicYear = res.data.data.find(year => year.active_status);

            if (!this.activeAcademicYear) {
                this.activeAcademicYear = this.oldActiveAcademicYear;
            } else {
                const existingAcademicYear = res.data.data.find(year => year.id === this.activeAcademicYear.id);
                this.activeAcademicYear = existingAcademicYear || this.oldActiveAcademicYear;
            }

            this.fetchedAt = now;
        },
        async setActiveAcademicYear(id) {
            this.activeAcademicYear = this.academicYears.find(year => year.id === id);
            if (!this.activeAcademicYear) {
                throw new Error("Academic year not found");
            }
        },
        reset() {
            this.academicYears = [];
            this.activeAcademicYear = null;
            this.oldActiveAcademicYear = null;
            this.fetchedAt = 0;
        },
    },
});